__turbopack_context__.v({
  "bottom-section": "BundleBanner-module-scss-module__b0KdUa__bottom-section",
  "bundle-banner-description": "BundleBanner-module-scss-module__b0KdUa__bundle-banner-description",
  "bundle-banner-one-year-plan-headline": "BundleBanner-module-scss-module__b0KdUa__bundle-banner-one-year-plan-headline",
  "bundle-banner-value-props": "BundleBanner-module-scss-module__b0KdUa__bundle-banner-value-props",
  "bundle-banner-wrapper": "BundleBanner-module-scss-module__b0KdUa__bundle-banner-wrapper",
  "bundle-logo": "BundleBanner-module-scss-module__b0KdUa__bundle-logo",
  "button": "BundleBanner-module-scss-module__b0KdUa__button",
  "feature-one": "BundleBanner-module-scss-module__b0KdUa__feature-one",
  "feature-three": "BundleBanner-module-scss-module__b0KdUa__feature-three",
  "feature-two": "BundleBanner-module-scss-module__b0KdUa__feature-two",
  "first-section": "BundleBanner-module-scss-module__b0KdUa__first-section",
  "float-features-item": "BundleBanner-module-scss-module__b0KdUa__float-features-item",
  "float-features-text": "BundleBanner-module-scss-module__b0KdUa__float-features-text",
  "float-features-wrapper": "BundleBanner-module-scss-module__b0KdUa__float-features-wrapper",
  "headline": "BundleBanner-module-scss-module__b0KdUa__headline",
  "main-image": "BundleBanner-module-scss-module__b0KdUa__main-image",
  "main-img-wrapper": "BundleBanner-module-scss-module__b0KdUa__main-img-wrapper",
  "money-back-guarantee": "BundleBanner-module-scss-module__b0KdUa__money-back-guarantee",
  "price": "BundleBanner-module-scss-module__b0KdUa__price",
  "pricing-logo-wrapper": "BundleBanner-module-scss-module__b0KdUa__pricing-logo-wrapper",
  "pricing-wrapper": "BundleBanner-module-scss-module__b0KdUa__pricing-wrapper",
  "second-section": "BundleBanner-module-scss-module__b0KdUa__second-section",
});
